import config from './config';

// '+' excluded from the local part on purpose: RFC 5233 sub-addressing would let
// a single mailbox register multiple accounts. Kept in sync with
// /paxity/generic#/definitions/mailWithoutSubAddressing (server). Dev/demo builds
// relax it to ease test-account creation, matching relaxEmailSubAddressingForDev on the server.
const allowSubAddressing = config.dev || config.demo;

const regex = {
  // email: /^[,\s;]*[\w.-]+@[\w.-]+\.\w+([,\s;]+[\w.-]+@[\w.-]+\.\w+)*[,\s;]*$/,
  email: allowSubAddressing
    ? /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
    : /^[a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  // firstLastname: /^[a-zA-ZÀ-ÏÑ-ÖÙ-Ýà-öù-ýÿŒœ](['a-zA-ZÀ-ÏÑ-ÖÙ-Ýà-öù-ýÿŒœ -]{0,97})?[a-zA-ZÀ-ÏÑ-ÖÙ-Ýà-öù-ýÿŒœ]$/,
  firstLastname: /^[a-zA-ZÀ-ÏÑ-ÖÙ-Ýà-öù-ýŒœ](['a-zA-ZÀ-ÏÑ-ÖÙ-Ýà-öù-ýŒœ -]{0,97})[a-zA-ZÀ-ÏÑ-ÖÙ-Ýà-öù-ýŒœ]$/,
  // text100chars: "^((?!.*[Ð×Þß÷þø])(?![. '\\-,)])[#0-9/\"\\-+',.:;()a-zA-ZÀ-ÿ&Œœč ?%{}!]{0,100})(?<![ '\\-])$"
  text100chars: /^[#0-9/"\-_<>+',.:;()a-zA-ZÀ-ÏÑ-ÖÙ-Ýà-öù-ýŒœ ?%{}!]{0,100}$/,
  text100charsMultiline: /^[#0-9/"\-_<>+',.:;()a-zA-ZÀ-ÏÑ-ÖÙ-Ýà-öù-ýŒœ ?%{}!\n\r]{0,100}$/,
  // /paxity/generic#/definitions/text1000chars: no lookaround, so its edge rules are the first and last classes
  text1000charsMultiline: /^(?:[#0-9/"—*_<>+:;(a-zA-ZÀ-ÏÑ-ÖÙ-Ýà-öù-ýÿ&Œœč?%{}!\n@€$=~°²[\]](?:[#0-9/"—*_<>+',.:;()a-zA-ZÀ-ÏÑ-ÖÙ-Ýà-öù-ýÿ&Œœč ?%{}!\n@\u00A0€$=~°²[\]-]{0,998}[#0-9/"—*_<>+,.:;()a-zA-ZÀ-ÏÑ-ÖÙ-Ýà-öù-ýÿ&Œœč?%{}!\n@€$=~°²[\]])?)?$/,
  text50chars: /^[#0-9/"\-+',.:;()a-zA-ZÀ-ÏÑ-ÖÙ-Ýà-öù-ýŒœ ?%{}!]{0,50}$/,
  // pxLabel: "^((?!.*[Ð×Þß÷þø])(?![ '-])[0-9-&'a-zA-ZÀ-ÿŒœ ]{3,99})(?<![ '-])$"
  pxLabel: /^[0-9&-'a-zA-ZÀ-ÏÑ-ÖÙ-Ýà-öù-ýŒœ ]{3,99}$/,
  // text2to45alphanum: /^((?!.*[Ð×Þß÷þø])(?![. '\-,)])[:+;0-9\-',.()a-zA-ZÀ-ÿŒœč ]{2,45})(?<![ '\-,(:;])$/
  text2to45alphanum: /^[:+;0-9\-',.()a-zA-ZÀ-ÿŒœč ]{2,45}$/,
  // Same strings as /paxity/generic#/definitions/companySearchName and postCodePrefix
  companySearchName: /^[0-9a-zA-ZÀ-ÖØ-öø-ÿŒœ][0-9a-zA-ZÀ-ÖØ-öø-ÿŒœ '&.-]{1,99}$/,
  postCodePrefix: /^[0-9]{2,5}$/,
  // /paxity/generic#/definitions/customerName: no lookaround, so its edge rules are the first and last classes
  customerName: /^(?:[0-9a-zA-ZÀ-ÏÑ-ÖÙ-Ýà-öù-ýÿŒœč.](?:[-'0-9a-zA-ZÀ-ÏÑ-ÖÙ-Ýà-öù-ýÿŒœč .]{0,98}[0-9a-zA-ZÀ-ÏÑ-ÖÙ-Ýà-öù-ýÿŒœč.])?)?$/,
  text2to30alphanum: /^[:+;0-9\-',.()a-zA-ZÀ-ÿŒœč ]{2,30}$/,

  telephone: /^(\+33|0)[0-9]{9}$/,
};

export default regex;
